<template>
  <section class="py-1 policies-section">
    <div class="row">
      <div class="col-12">
        <div class="card soft-card policies-filter">
          <div class="soft-card-header">
            <h6>Filter</h6>
          </div>
          <div class="card-body d-flex flex-wrap policies-filter-body">
            <story-avatar v-for="({ name, image, isActive, id }, index) of insureTypes" :key="index"
              :image="image" :name="name" :is-active="isActive" @click="pickType(id, isActive)" />
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3 row mt-lg-4">
      <div v-for="list in policyList" :key="list.policyId" class="mb-4 col-lg-4 col-md-6"
        @click="goToPolicy(list)">
        <projects-card :image="medical" :title="list.policySeries + list.policyNumber" sub-title="Medical"
          :amount="list.cardsCount" :description="$t('policyVoluntaryDesc')"
          :date-time="formatDate(list.startDate)" :end-date-time="formatDate(list.endDate)" :dropdown="[
              {
                label: $t('commonCancel'),
                route: 'javascript:;',
              },
              {
                label: $t('commonAdd'),
                route: 'javascript:;',
              },
              {
                label: $t('commonPrint'),
                route: 'javascript:;',
              },
            ]" />
      </div>
    </div>
  </section>
</template>

<script>
import medical from "@/assets/img/icons/insurence/medical.png";
import motor from "@/assets/img/icons/insurence/motor.png";
import property from "@/assets/img/icons/insurence/property.png";
import ProjectsCard from "./ComplexProjectCard.vue";
import StoryAvatar from "./StoryAvatar.vue";
import { weblink } from  '@/project/Source/helper.js'

// import PlaceHolderCard from "@/examples/Cards/PlaceHolderCard.vue";
export default {
  components: {
    ProjectsCard,
    StoryAvatar,
    // PlaceHolderCard,
  },
  props: {
    policyList: Array,
  },
  data() {
    return {
      insureTypes: [
        {
          id: 1,
          name: "Medical",
          image: medical,
          isActive: true,
        },
        {
          id: 2,
          name: "Motor",
          image: motor,
          isActive: false,
        },
        {
          id: 3,
          name: "Əmlak",
          image: property,
          isActive: false,
        },
      ],
      showMenu: false,
      medical,
      motor,
      property,
    };
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = String(date.getFullYear()).slice(2);

      return `${day}.${month}.${year}`;
    },
    pickType(id, active) {
      if (!active) {
        // this.multipleSelection.push(val);
        let objectToChange = this.insureTypes.find((item) => item.id === id);
        objectToChange.isActive = true;
      } else {
        // let indexToRemove = this.multipleSelection.findIndex(item => item.serviceId === id);
        // this.multipleSelection.splice(indexToRemove, 1);
        let objectToChange = this.insureTypes.find((item) => item.id === id);
        objectToChange.isActive = false;
      }
    },
    goToPolicy(list) {
      sessionStorage.setItem("policy", JSON.stringify(list.policyId));
      sessionStorage.setItem(
        "policyNumber",
        JSON.stringify(`${list.policySeries}${list.policyNumber}`)
      );
      window.location.href = `${weblink}policy?id=${list.policyId}`
    }
  },
};
</script>

<style scoped>
.policies-filter {
  min-height: 140px;
}

.policies-filter-body {
  padding: 0.75rem 1rem 1.25rem !important;
  gap: 0.35rem;
}
</style>